import { render, staticRenderFns } from "./ServicePointCloseReasonSelect.vue?vue&type=template&id=2ed77567&scoped=true"
import script from "./ServicePointCloseReasonSelect.vue?vue&type=script&lang=js"
export * from "./ServicePointCloseReasonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed77567",
  null
  
)

export default component.exports